// Pricing logic for architecture projects

export const calculateEstimate = (formData) => {
  let basePrice = 0;
  let designCost = 0;
  let planningCost = 2500; // Standard planning application cost

  // Base price by property type
  const propertyMultipliers = {
    'detached': 1.2,
    'semi-detached': 1.1,
    'terraced': 1.0,
    'flat': 0.9,
    'bungalow': 1.15
  };

  // Project type base costs
  const projectBaseCosts = {
    'extension': {
      'rear': 3500,
      'side': 3200,
      'side-infill': 2800,
      'wraparound': 4500,
      'side-and-rear': 4200,
      'two-storey': 5500
    },
    'loft': {
      'dormer': 3800,
      'hip-to-gable': 4200,
      'hip-to-gable-main': 4800,
      'hip-to-gable-no': 3500,
      'l-shaped': 4500,
      'mansard': 5200,
      'velux': 2800,
      'outrigger': 4000
    },
    'first-floor': {
      'side-and-rear': 5000,
      'rear': 4200,
      'rear-over-outrigger': 4500,
      'rear-over-ground': 4800,
      'side': 3800
    },
    'basement': {
      'full': 6500,
      'partial': 4500,
      'extension': 5500
    },
    'other': {
      'garage-conversion': 2500,
      'garden-annex': 4000,
      'two-storey-rear': 5500,
      'two-storey-side': 5200
    },
    'new-build': 8000,
    'renovation': 3500
  };

  // Get base design cost
  if (formData.projectType && formData.specificType) {
    const projectCosts = projectBaseCosts[formData.projectType];
    if (projectCosts) {
      basePrice = projectCosts[formData.specificType] || projectCosts;
    }
  } else if (formData.projectType) {
    // If no specific type yet, use average for project type
    const projectCosts = projectBaseCosts[formData.projectType];
    if (typeof projectCosts === 'object') {
      const values = Object.values(projectCosts);
      basePrice = values.reduce((a, b) => a + b, 0) / values.length;
    } else {
      basePrice = projectCosts || 3500;
    }
  }

  // Apply property type multiplier
  const multiplier = propertyMultipliers[formData.propertyType] || 1.0;
  designCost = Math.round(basePrice * multiplier);

  // Bedroom adjustment (complexity factor)
  if (formData.bedrooms) {
    const bedroomCount = formData.bedrooms === '5+' ? 5 : parseInt(formData.bedrooms);
    if (bedroomCount >= 4) {
      designCost = Math.round(designCost * 1.1);
    }
  }

  // Calculate ranges (±15%)
  const minPrice = Math.round(designCost * 0.85);
  const maxPrice = Math.round(designCost * 1.15);

  const totalMin = minPrice + planningCost;
  const totalMax = maxPrice + planningCost;

  return {
    designMin: minPrice,
    designMax: maxPrice,
    planning: planningCost,
    totalMin,
    totalMax,
    designAverage: designCost
  };
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};
